import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { env } from '~/app/environment';
import { useTenantContext } from '~/common/providers/auth/TenantProvider';

const LOGLASS_TENANT_HEADER_NAME = 'X-Loglass-Tenant-Id';

type ReqOptions = {
  headers: {
    authorization: string;
    [LOGLASS_TENANT_HEADER_NAME]?: string | undefined;
  };
};

type UseAuthReqOptions = {
  getAuthReqOptions: () => Promise<ReqOptions>;
};

const useAuthReqOptions = (): UseAuthReqOptions => {
  const { getAccessTokenSilently } = useAuth0();
  const { tenantId } = useTenantContext();

  const getAuthReqOptions = useCallback(async () => {
    const environment = env();
    if (!environment) {
      throw Error('環境変数が設定されていません');
    }
    const token = await getAccessTokenSilently();

    return {
      headers: {
        authorization: `Bearer ${token}`,
        [LOGLASS_TENANT_HEADER_NAME]: tenantId,
      },
    };
  }, [getAccessTokenSilently, tenantId]);

  return { getAuthReqOptions };
};

export { useAuthReqOptions };
export type { ReqOptions, UseAuthReqOptions };
